import Axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../components/Common/Header/Header";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await Axios.post("https://lawacademyadmin.icicle.dev/api/userLogin", {
        email,
        password,
      });
      // console.log(response);

      if (response.status === 200 && response.data.status === "ok") {
        const token = response.data.token;

        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Login Successfull",
          confirmButtonText: "Ok",
          confirmButtonColor: "#006837",
        }).then(() => {
          navigate("/userProfile");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Login failed. Please check your credentials.",
          confirmButtonText: "Ok",
          confirmButtonColor: "red",
        });
        console.error("Login failed:", response.data.msg);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response.data.error}`,
        confirmButtonText: "Ok",
        confirmButtonColor: "red",
      });
      // console.log(error);
    }
  };

  // const clickAdminLogin = () => {
  //   // console.log("click")
  //   window.location.href = "https://lawacademyadmin.icicle.dev/login";
  // };

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div className="account-page login text-center">
          <div className="container">
            <div className="account-title">
              <h4 className="heading-light">LOG IN</h4>
            </div>
            <div className="account-content">
              <form onSubmit={handleSubmit}>
                <div className="input-box email">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="input-box password">
                  <input
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="buttons-set">
                  <button type="submit" className="bnt bnt-theme text-regular text-uppercase">
                    LOG IN
                  </button>
                </div>
                <div style={{ marginTop: "20px" }}>
                  <Link to={""} className="admin-login">
                    Forget Password
                  </Link>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    justifyContent: "center",
                    marginTop: "5px",
                  }}
                >
                  <div>Please login as an</div>

                  <a
                    href="https://lawacademyadmin.icicle.dev/login"
                    target="_blank"
                    rel="noreferrer"
                    className="admin-login"
                    style={{
                      cursor: "pointer",
                      fontSize: "13px",
                      color: "#47517C",
                      fontWeight: 900,
                    }}
                  >
                    Admin
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
